import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const fileManagerImgUploadFn = ({ formData }) =>
  apiClient.post(`${APP_API_URL_V2}file-manager/img-upload`, formData, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });

export const useFileManagerImgUploadMutation = () => {
  return useMutation({
    mutationFn: fileManagerImgUploadFn,
  });
};
